<template>
  <div class="modal">
    <div class="wrap">
      <div class="title">职场老手教你<br />如何辨别企业【真假】项目课程</div>
      <div class="desc">
        商用级项目才真正具备企业价值。<br />
        博学谷每一套项目课程都要经过<span>8次</span>品控把关，<br />
        从立项到研发，再到上线，选取经典业务场景，<br />
        每一环节至少<span>10项</span>验收标准，只为你能学到更优质的课程。<br />
        学会辩项目真伪，才能找到好工作。
      </div>
      <div class="content">
        <div class="heng1"></div>
        <div class="heng2"></div>
        <div class="heng3"></div>
        <div class="left">
          <div class="subTitle">真项目</div>
          <p>
            从0到1完整还原企业真<br />
            实研发周期，可商用的<br />
            产品设计、技术实现
          </p>
          <p>
            符合企业需求的部署、<br />
            测试与运维监控，项目<br />
            研发人员均来自大厂
          </p>
          <p>
            依据市场需求及教学反<br />
            馈，紧跟行业发展持续<br />
            迭代优化
          </p>
          <p>
            项目文档配套完整，一<br />
            应俱全！
          </p>
        </div>
        <div class="right">
          <div class="subTitle">假项目</div>
          <p>
            文字游戏不能体验，<br />
            或断章取义，无完整<br />
            开发全流程
          </p>
          <p>
            项目不维护、不更新，<br />
            架构与研发不专业，<br />
            不严谨
          </p>
          <p>
            项目与行业脱节，知<br />
            识零碎不成体系
          </p>
          <p>
            需求文档、开发文档<br />
            看似完整，实则堆砌<br />
            无意义
          </p>
        </div>
        <div class="border">
          <div class="closeBtn" @click="close"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flag: false,
    };
  },
  methods: {
    close() {
     this.$emit("closeModal")
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  width: 100%;
  height: 100%;
  background-color: rgba(55, 55, 55, 0.6);
  z-index: 170;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  .wrap {
    width: 650px;
    height: 984px;
    background-color: #ffffff;
    border-radius: 36px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    .title {
      font-family: PingFangSC-Semibold;
      font-size: 32px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 44px;
      letter-spacing: 0px;
      color: #1f324d;
      margin: 30px 0 10px;
    }
    .desc {
    font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 36px;
      letter-spacing: 0px;
      color: #1f324d;
      span {
        font-family: PingFangSC-Semibold;
        font-size: 24px;
        font-weight: normal;
        letter-spacing: 0px;
        color: #ff4d24;
      }
    }
    .content {
      width: 590px;
      height: 565px;
      background-color: #d6e7ff;
      border-radius: 20px;
      display: flex;
      margin: 50px auto 0;
      position: relative;
      .heng1 {
        position: absolute;
        width: 552px;
        height: 1px;
        background-color: #ebf3ff;
        z-index: 10;
        top: 196px;
        left: 50%;
        transform: translateX(-50%);
      }
      .heng2 {
        position: absolute;
        width: 552px;
        height: 1px;
        background-color: #ebf3ff;
        top: 310px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
      }
      .heng3 {
        position: absolute;
        width: 552px;
        height: 1px;
        background-color: #ebf3ff;
        top: 425px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
      }
      .left {
        width: 320px;
        height: 605px;
        background-image: linear-gradient(90deg, #3388ff 0%, #66a6ff 100%);
        border-radius: 20px;
        position: relative;
        top: -20px;
        text-align: left;
        padding: 50px 0 0 37px;
        box-sizing: border-box;
        .subTitle {
          font-family: PingFangSC-Semibold;
          font-size: 30px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 36px;
          letter-spacing: 0px;
          color: #ffffff;
          margin-bottom: 30px;
          margin-left: 86px;
        }
        p {
          font-family: PingFang SC;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 0px;
          color: #ffffff;
          margin-bottom: 30px;
        }
      }
      .right {
        width: 270px;
        text-align: center;
        padding: 30px 0 0 25px;
        text-align: left;
        box-sizing: border-box;
        .subTitle {
          font-family: PingFangSC-Semibold;
          font-size: 30px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 36px;
          letter-spacing: 0px;
          color: #1f324d;
          margin-bottom: 30px;
          margin-left: 65px;
        }
        p {
          font-family: PingFang SC;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 0px;
          color: #596980;
          margin-bottom: 30px;
        }
        p:nth-child(4) {
          margin-bottom: 58px;
        }
      }
    }
  }
  .border {
    position: absolute;
    bottom: -153px;
    left: 50%;
    transform: translateX(-50%);
    border: 4px solid #ffffff;
    border-radius: 50%;
    padding: 3px;
  }
  .closeBtn {
    background: url("../../../assets/coursePage/common/closeBtn.png");
    width: 36px;
    height: 36px;
    background-size: cover;
  }
}
</style>
